import Icon  from "../../icon";
import { CIRCLE_CHECK_BIG } from "icons";
import { cn } from "utils";
import { Card, CardContent } from "ui/components/card";
import { COMMON_CLASSES_FOR_CARD } from "./utils";

export default function AcknowledgmentCard({
  totalLogsInADay,
  isAcknowledged,
  onAcknowledge,
  ...props
}) {
  if (isAcknowledged && totalLogsInADay) {
    return null;
  }

  const handleAcknowledge = () => {
    if (!isAcknowledged) {
      onAcknowledge();
    }
  };

  return (
    <Card
      className={cn(
        COMMON_CLASSES_FOR_CARD,
        "cursor-pointer",
        isAcknowledged ? "bg-primary-foreground" : "border-2 border-dashed",
        props.className
      )}
      onClick={handleAcknowledge}
    >
      <CardContent className="flex w-full h-full items-center gap-3 justify-center flex-col">
        <div
          className={cn(
            "size-9 flex justify-center items-center rounded-full flex-none",
            !isAcknowledged ? "bg-red-50" : "bg-white"
          )}
        >
          <Icon
            icon={CIRCLE_CHECK_BIG}
            className={cn(
              !isAcknowledged ? "text-red-900 " : "text-muted-foreground"
            )}
          />
        </div>

        <span className="font-semibold text-sm">
          {isAcknowledged ? "Acknowledged" : "Acknowledge"}
        </span>
        <p className="text-xs text-center text-muted-foreground">
          {isAcknowledged
            ? ""
            : "This confirms your timesheet is complete, even without logged hours."}
        </p>
      </CardContent>
    </Card>
  );
}
